var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGcloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6529 5.55041H16.3852L18.4723 3.46328L18.5748 2.57717C16.1441 0.431675 12.7777 -0.306569 9.67218 0.624798C6.56663 1.55617 4.16215 4.0251 3.31323 7.15419C3.54575 7.05889 3.80331 7.04344 4.04556 7.11026L8.2198 6.42187C8.2198 6.42187 8.43217 6.07036 8.54202 6.09233C10.3988 4.05307 13.5237 3.81542 15.6675 5.55041H15.6529Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4455 7.15417C20.9658 5.38754 19.9808 3.79936 18.6114 2.58447L15.6821 5.51377C16.919 6.52446 17.6236 8.047 17.5935 9.64407V10.164C19.0333 10.164 20.2005 11.3312 20.2005 12.7711C20.2005 14.2109 19.0333 15.3782 17.5935 15.3782H12.3793L11.8594 15.9054V19.0325L12.3793 19.5524H17.5935C20.5831 19.5757 23.2352 17.6384 24.1222 14.7833C25.0093 11.9283 23.9219 8.82914 21.4455 7.15417Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1579 19.5231H12.372V15.3488H7.1579C6.78641 15.3488 6.41928 15.2688 6.08138 15.1145L5.34906 15.3415L3.24729 17.4286L3.06421 18.161C4.24283 19.051 5.681 19.5295 7.1579 19.5231Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15796 5.98247C4.26169 5.99977 1.6961 7.85461 0.771767 10.5995C-0.152561 13.3444 0.768433 16.3733 3.06428 18.139L6.08877 15.1145C5.03205 14.6371 4.41767 13.5191 4.58114 12.3712C4.74461 11.2232 5.64665 10.3211 6.79463 10.1577C7.94262 9.99419 9.06059 10.6086 9.53802 11.6653L12.5625 8.6408C11.2757 6.95849 9.27601 5.97491 7.15796 5.98247Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcloud);
export default __webpack_public_path__ + "static/media/gcloud.010d8ff6dc470b4e04ab86a3c3ea339f.svg";
export { ForwardRef as ReactComponent };